<mat-form-field appearance="outline">
  <mat-label>
    @if (isRequired()) {
      <span>{{ label() }}*</span>
    } @else {
      <span>{{ label() }}</span>
    }
  </mat-label>

  <mat-chip-grid #chipGrid [formControl]="formControl">
    @for (option of values(); track identify(option)) {
      <mat-chip-row style="overflow: hidden" [removable]="true" (removed)="removeValue(option)">
        <span>{{ displayWith()(option) }}</span>
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>

  <input
    matInput
    placeholder="Type to search"
    [matChipInputFor]="chipGrid"
    [matAutocomplete]="auto"
    (input)="onSearchEvent($event)"
    (keydown.enter)="onSearchEvent($event)"
  />

  @if (!resource().isLoading()) {
    <mat-icon matSuffix>search</mat-icon>
  } @else {
    <mat-spinner diameter="24" style="margin: 12px" matSuffix></mat-spinner>
  }

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="addValue($event.option.value)"
    [displayWith]="displayWith()"
  >
    @if (resource().hasValue()) {
      @for (item of resource().value(); track identify(item)) {
        <mat-option [value]="item">{{ displayWith()(item) }}</mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
